// React
import { useHistory, useParams } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

// Yup Validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Data Injection
import { CategoriesFinanceInjection } from '../../containers/categoriesFinanceInjection';

// View
import { CategoriesFinanceFormPage } from './view';

// Helpers
import { APIClient } from '../../../../helpers/api_helper';

export const CategoriesFinanceForm = () => {
  const [type, setType] = useState();
  const [categoryFinance, setCategoryFinance] = useState(null);
  const [parent, setParent] = useState({
    value: '',
    label: '',
  });

  const {
    getCategoriesFinance,
    getCategoriesFinanceSelect,
    createCategoriesFinance,
    updateCategoriesFinance,
    success,
    categoryFinances,
    categoryFinanceSelect,
  } = CategoriesFinanceInjection();

  const { id } = useParams();
  const api = new APIClient();
  const history = useHistory();

  const findCategory = async (id) => {
    const categoryFound = await api.get(`/register/financial-category/${id}`);

    if (categoryFound) {
      setCategoryFinance(categoryFound);
      getParent(categoryFound.parent_id);
    }
  };

  const getParent = async (idParent) => {
    if (idParent !== null) {
      let parentFound = await api.get(
        `/register/financial-category/${idParent}`
      );

      if (parentFound) {
        setParent({
          value: parentFound.id,
          label: parentFound.name,
        });
      }
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      nameInput: categoryFinance ? categoryFinance.name : '',
      subCategoryOf:
        categoryFinance && categoryFinance.parent_id !== null ? parent : null,
    },
    validationSchema: Yup.object({
      nameInput: Yup.string().required('Nome é obrigatório'),
      subCategoryOf: Yup.object().nullable(),
    }),

    onSubmit: (values) => {
      const valuesToSubmit = {
        type,
        active: true,
        name: values.nameInput || null,
        parent_id: values.subCategoryOf ? values.subCategoryOf.value : null,
      };

      if (categoryFinance) {
        updateCategoriesFinance(
          {
            id: categoryFinance.id,
            ...valuesToSubmit,
          },
          history
        );
      } else {
        createCategoriesFinance(valuesToSubmit, history);
      }
    },
  });

  useEffect(() => {
    getCategoriesFinance();
    if (type) {
      getCategoriesFinanceSelect(type);
    }
  }, [type, success]);

  useEffect(() => {
    if (id) {
      findCategory(id);
    }
  }, [id]);

  useEffect(() => {
    const full_url = document.URL; // Get current url
    const url_array = full_url.split('/'); // Split the string into an array with / as separator
    const last_segment = url_array[url_array.length - 1];
    setType(last_segment === 'despesas' ? 'D' : 'R');
  }, []);

  return (
    <CategoriesFinanceFormPage
      id={id}
      type={type}
      history={history}
      validation={validation}
      categoryFinanceSelect={categoryFinanceSelect}
    />
  );
};
